import React from 'react';
import PropTypes from 'prop-types';
import {
  VStack,
  Text,
  Box,
  Image,
  Grid,
  GridItem,
  List,
  ListItem,
  ListIcon,
  Heading,
} from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';

function RegistrationComplete({ registrationData, onComplete }) {
  return (
    <Grid templateColumns="1fr 2fr" gap={8} p={4}>
      {/* Product Info Column */}
      <GridItem>
        <VStack spacing={4} align="start">
          <Image
            src={registrationData.image}
            alt={registrationData.model}
            boxSize="200px"
            objectFit="contain"
            fallbackSrc="https://via.placeholder.com/200"
          />
        </VStack>
      </GridItem>

      {/* Registration Details Column */}
      <GridItem>
        <VStack spacing={6} align="stretch">
          <Box>
            <Heading size="md" color="green.500" mb={4}>
              Registration Successful!
            </Heading>
            <Text fontSize="lg" mb={6}>
              Your product has been successfully registered to your account.
            </Text>
          </Box>

          <List spacing={3}>
            {registrationData.serialNumber && (
              <ListItem>
                <ListIcon as={CheckCircleIcon} color="green.500" />
                <Text as="span" fontWeight="bold">Serial Number:</Text>
                {' '}{registrationData.serialNumber}
              </ListItem>
            )}
            {registrationData.purchaseDate && (
              <ListItem>
                <ListIcon as={CheckCircleIcon} color="green.500" />
                <Text as="span" fontWeight="bold">Purchase Date:</Text>
                {' '}{registrationData.purchaseDate}
              </ListItem>
            )}
            <ListItem>
              <ListIcon as={CheckCircleIcon} color="green.500" />
              <Text as="span" fontWeight="bold">Registration Date:</Text>
              {' '}{registrationData.registrationDate}
            </ListItem>
            <ListItem>
              <ListIcon as={CheckCircleIcon} color="green.500" />
              <Text as="span" fontWeight="bold">Product Name:</Text>
              {' '}{registrationData.name}
            </ListItem>
            <ListItem>
              <ListIcon as={CheckCircleIcon} color="green.500" />
              <Text as="span" fontWeight="bold">SKU:</Text>
              {' '}{registrationData.id}
            </ListItem>
            <ListItem>
              <ListIcon as={CheckCircleIcon} color="green.500" />
              <Text as="span" fontWeight="bold">Product Type:</Text>
              {' '}{registrationData.type}
            </ListItem>
          </List>
        </VStack>
      </GridItem>
    </Grid>
  );
}

RegistrationComplete.propTypes = {
  registrationData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired,
    serialNumber: PropTypes.string.isRequired,
    purchaseDate: PropTypes.string,
    registrationDate: PropTypes.string.isRequired,
  }).isRequired,
  onComplete: PropTypes.func.isRequired,
};

export default RegistrationComplete; 